export const thunkTypes = {
  LIST_QUEUE: `reschedules/listQueue`,
  LIST_AMBASSADORS: `reschedules/listAmbassadors`,
  REPROGRAM: `reschedules/reprogram`,
  ESCALATE: `reschedules/escalate`,
  LOAD_MAX_ATTEMPTS: `reschedules/loadMaxAttempts`,
};
